<template>
  <div class="position-relative">
    <img class="custom-icon" :src="mail" />
  </div>
</template>
<script>
import mail from "@/assets/icons/email.png";
export default {
  data() {
    return {
      mail,
    };
  },
  components: {},
};
</script>
<style lang="scss" scoped>
.custom-icon {
  height: 1.6rem;
  width: auto;
}
</style>
